module.exports = __webpack_public_path__ + "static/media/follower_3.d62aebcd.png";